import { MenuItem, Select } from '@material-ui/core';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useStateValue } from '../context/StateProvider';
import './SideDrawer.css'

function SideDrawer({logOut, show, click}) {
    let drawerClass = 'side__drawer'

    const [category, setCategory] = useState("beauty");
    const [value, setValue] = useState(0)

    const [{user, isAdmin}, dispatch] = useStateValue()

    const handleChange = (e) => {

        let newCategory = e.target.value
        switch(newCategory) {
            case 1:
                setCategory("wellness")
                setValue(1)
                
                break;
            case 2:
                setCategory("massage")
                setValue(2)
                
                break;
            case 3:
                setCategory("enhancments")
                setValue(3)
                
                break;
            case 4:
                setCategory("toys")
                setValue(4)

                break;
            case 6:
                setCategory("lubricant")
                setValue(6)
                
                break;
            case 5:
                setCategory("lingerie")
                setValue(5)
                
                break;
            case 7:
                setCategory("vaginalHealth")
                setValue(7)
                
                break;
            case 13:
                setCategory("rolePlay")
                setValue(13)
                
                break;
            case 8:
                setCategory("malePleasure")
                setValue(8)
                break;
            case 9:
                setCategory("clitoral")
                setValue(9)
                break;
            case 10:
                setCategory("gSpot")
                setValue(10)
                break;
            case 11:
                setCategory("dual")
                setValue(11)
                break;
            case 12:
                setCategory("booty")
                setValue(12)
                break;
            case 14:
                setCategory("c-rings")
                setValue(14)
                break;
            default:
                setCategory("beauty")
                setValue(0)
                
        } 
    }

    useEffect(() => {
        
            dispatch({
                type: 'SET_CATEGORY',
                category: category,
            })
        

    },[dispatch, category])

    if(show) {
        drawerClass = 'side__drawer open'
    }


    return (
        <div className={drawerClass}>
            <h4>PROUDUCT CATEGORIES</h4>
            <Select
                value={value}
                onChange={(e) => handleChange(e)}
            >
                <MenuItem value={0} label="beauty">Beauty</MenuItem> 
                <MenuItem value={1} label="wellness" >Wellness</MenuItem>
                <MenuItem value={2} label="massage" >Massage</MenuItem>
                <MenuItem value={3} label="enhancments" >Enhancments</MenuItem>
                <MenuItem value={13} label="role play" >Role Play</MenuItem>
                <MenuItem value={5} label="lingerie">Lingerie</MenuItem>
                <MenuItem value={6} label="lubricant">Lubricant</MenuItem>
                <MenuItem value={7} label="vaginal Health">Vaginal Health</MenuItem>
                <MenuItem value={8} label="malePleasure">Male Pleasure Toys</MenuItem>
                <MenuItem value={9} label="clitoral">Clitoral Toys</MenuItem>
                <MenuItem value={10} label="g-spot">G-Spot Toys</MenuItem>
                <MenuItem value={11} label="dual">Dual Toys</MenuItem>
                <MenuItem value={12} label="booty">Booty Toys</MenuItem>
                <MenuItem value={14} label="c-rings">C-Rings</MenuItem>
            </Select>
            <NavLink to="/" onClick={click}>Home</NavLink> 
            <NavLink to="/Cart" onClick={click}>Cart</NavLink> 
            <NavLink to="/Videos" onClick={click}>Videos</NavLink>
            <NavLink to="/Review" onClick={click}>Reviews</NavLink> 
            <NavLink to="/Orders" onClick={click}>Orders</NavLink>
            {
                            isAdmin?  
                            <NavLink to="/Admin" onClick={click}>Dashboard</NavLink> : ''
                        }
            {
                user? 
                <NavLink to="/Log In" onClick={logOut}>Log Out</NavLink>
                :
                <NavLink to="/Log In" onClick={click}>Log In</NavLink>
            }
        </div>
    );
}

export default SideDrawer;